import React from 'react';
import { HomeIcon, MapPinIcon, RepeatIcon, UserRoundIcon } from 'lucide-react';
import { loan } from '../../data/loan';
export function LoanSummaryBar() {
  return <section aria-label="Loan reference information" className="rounded-2xl border border-slate-200 bg-white px-5 py-4 shadow-sm" data-id="element-112" data-mp="1ghy0w9cn9zgf">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-3" data-id="element-113" data-mp="17knlqcwphq68">
        <div className="flex items-center gap-3" data-id="element-114" data-mp="1v9gootbqwyac">
          <span aria-hidden="true" className="flex h-9 w-9 items-center justify-center rounded-full bg-slate-100 text-slate-500" data-id="element-115" data-mp="1v9qeogwsj5g1">
            <UserRoundIcon className="h-4 w-4" data-id="element-116" data-mp="1lk6tv5pip1ij" />
          </span>
          <div data-id="element-117" data-mp="1qii59kvgnk2v">
            <p className="text-sm font-semibold text-slate-900" data-id="element-118" data-mp="1qi8aljzh0oqu">{loan.borrower}</p>
            <p className="text-xs text-slate-500" data-id="element-119" data-mp="2e82om4vj0jco">Loan #{loan.loanNumber}</p>
          </div>
        </div>

        <span aria-hidden="true" className="hidden h-8 w-px bg-slate-200 sm:block" data-id="element-120" data-mp="2iyswppvc70b2" />

        <dl className="flex flex-wrap items-center gap-x-6 gap-y-2 text-sm" data-id="element-121" data-mp="2j0m4x9lllsl6">
          <div className="flex items-center gap-2" data-id="element-122" data-mp="o1cqh4i8k42r">
            <RepeatIcon aria-hidden="true" className="h-4 w-4 text-slate-400" data-id="element-123" data-mp="k0189k1oyl4l" />
            <dt className="sr-only" data-id="element-124" data-mp="xqmjqnotfssg">Transaction type</dt>
            <dd className="text-slate-600" data-id="element-125" data-mp="xsh9cfb1892v">{loan.transactionType}</dd>
          </div>
          <div className="flex items-center gap-2" data-id="element-126" data-mp="szebhuz82dgv">
            <HomeIcon aria-hidden="true" className="h-4 w-4 text-slate-400" data-id="element-127" data-mp="17p2f52uvlo7r" />
            <dt className="sr-only" data-id="element-128" data-mp="17r6ow1fghhfy">Property type</dt>
            <dd className="text-slate-600" data-id="element-129" data-mp="12oxud0mxq7bq">{loan.propertyType}</dd>
          </div>
          <div className="flex items-center gap-2" data-id="element-130" data-mp="1gqa7z5emhwug">
            <MapPinIcon aria-hidden="true" className="h-4 w-4 text-slate-400" data-id="element-131" data-mp="1goz3t4h9mn2t" />
            <dt className="sr-only" data-id="element-132" data-mp="1br73bm2k1sn0">Property address</dt>
            <dd className="text-slate-600" data-id="element-133" data-mp="3igvjmqaguj3e">
              {loan.addressLine}, {loan.cityStateZip}
            </dd>
          </div>
        </dl>
      </div>
    </section>;
}